// src/main.tsx
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import PricingPage from './pages/PricingPage';
import DashboardPage from './pages/DashboardPage';
import RegisterPage from './pages/RegisterPage';
import ChoosePlanPage from './pages/ChoosePlanPage';
import OAuthSuccessPage from './pages/OAuthSuccessPage';
import SupportPage from './pages/SupportPage';
import PrivacyPolicy from './pages/PrivacyPolicyPage';
import RefundPolicy from './pages/RefundPolicyPage';
import TermsOfService from './pages/TermsOfServicePage';
import './main.css';
import SettingsPage from './pages/dashboard/SettingsPage';
import ModernDashboardPage from './pages/dashboard/MainPage';
import ReposPage from './pages/dashboard/ReposPage';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem('authToken');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/login" element={<LoginPage />} />
          {/* <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } /> */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <ModernDashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/dashboard/repos" element={
            <ProtectedRoute>
              <ReposPage />
            </ProtectedRoute>
          } />
          <Route path="/dashboard/settings" element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          } />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/choose-plan" element={<ChoosePlanPage />} />
          <Route path="/oauth-success" element={<OAuthSuccessPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/refunds" element={<RefundPolicy />} />

          <Route path="/demo" element={<ModernDashboardPage />} />
          <Route path="/demo/repos" element={<ReposPage />} />  

        </Route>
      </Routes>
    </Router>
  </React.StrictMode>
);
